import React, { useState } from 'react';
import { Typography, Pagination } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify'; 
const NewsList = ({ filteredNews, onUpdate }) => {
    const [page, setPage] = useState(1);
    const itemsPerPage = 4; // Noticias por página
    const navigate = useNavigate();
    // Reemplaza tu sort original con esto:
    const sortedNews = filteredNews;

    const getPlainText = (html) => {
        const clean = DOMPurify.sanitize(html);
        const doc = new DOMParser().parseFromString(clean, 'text/html');
        return doc.body.textContent || '';
    };
    // Calcular total de páginas
    const pageCount = Math.ceil(sortedNews.length / itemsPerPage);

    // Obtener las noticias de la página actual
    const paginatedNews = sortedNews.slice((page - 1) * itemsPerPage, page * itemsPerPage);

    return (
        <div className="w-full mt-3 p-2">
            {filteredNews.length === 0 ? (
                <Typography variant="h6" align="center" sx={{ mt: 2 }}>
                    No existen noticias publicadas 🥲
                </Typography>
            ) : (
                <>
                    <div className="grid grid-cols-1 gap-6 w-full">
                        {paginatedNews.map((item) => (
                            <div
                                key={item.id}
                                className="relative cursor-pointer overflow-hidden rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1"
                                onClick={() => navigate(`/news/${item.id}`, { state: { news: filteredNews } })}
                                style={{ width: '100%', aspectRatio: '16 / 9' }}
                            >
                                <div className="absolute top-10  bg-gradient-to-b from-[#09274A] to-[#0488AF] text-white text-sm font-semibold px-4 py-1.5 rounded-r-lg shadow-lg z-20">
                                    {item.company?.trade_name || 'Empresa'}
                                </div>
                                {/* Imagen de fondo */}
                                <div
                                    style={{
                                        backgroundImage: `url(${item.image})`,
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                        height: '100%',
                                        width: '100%',
                                        transition: 'transform 0.5s ease',
                                    }}
                                    className="relative hover:scale-105"
                                    loading="lazy"
                                >
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-transparent md:from-black/70 md:via-transparent transition-opacity duration-300 hover:from-black/90" />
                                </div>

                                <div className="absolute bottom-0 left-0 p-3 md:p-4 text-white z-10 w-full">
                                    <div
                                        className="inline-block px-2 py-1 rounded-full text-xs font-bold uppercase mb-1 md:mb-2"
                                        style={{ backgroundColor: '#0488AF', color: 'white' }}
                                    >
                                        {item.category || "Sin categoría"}
                                    </div>
                                    <h2 className="text-lg md:text-2xl font-bold mb-1 md:mb-2 line-clamp-2">
                                        {item.title}
                                    </h2>
                                    <p className="text-xs md:text-sm opacity-90 line-clamp-2 sm:line-clamp-3 hidden sm:block">
                                    {(() => {
                                            const plain = getPlainText(item.description || '');
                                            return plain.length > 150 ? `${plain.substring(0, 150)}...` : plain || 'Sin descripción';
                                        })()}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Paginación */}
                    {pageCount > 1 && (
                        <div className="flex justify-center mt-4 md:mt-5">
                            <Pagination
                                count={pageCount}
                                page={page}
                                onChange={(event, value) => setPage(value)}
                                color="primary"
                                size="small"
                                siblingCount={0}
                                className="scale-90 md:scale-100"
                            />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default NewsList;
